import api from "@/core/api";

export const profile = (id: string) => api.query(`/users/${id}`);
export const logout = (id: string) => api.query(`/users/logout/${id}`);
export const beforeSave = (data: any) => api.query(`/users/beforesaveuser`, { method: "post", data });
